import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Grid, Container, makeStyles} from '@material-ui/core';

import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import Input from '../components/Input/Input';
import Button from '../components/Button/Button';

import { expirationCheck, contentAPI } from '../data-manager/info';
import { saveFormData } from '../store/form';

import { ArrowRight } from '@/assets/images/arrow';

// import {
//   preventSpecSymbols,
// } from '../utils.ts';

const useStyles = makeStyles(theme => ({
  root: {},
  container: {
    padding: '0 10px',
    paddingTop: '80px',
    minHeight: 'calc(100vh - 415px)',
    '@media (min-width: 1600px)': {
      maxWidth: '1440px',
    },
    '@media (max-width: 767px)': {
      padding: '30px 0 0',
    },
  },
  title: {
    fontSize: theme.typography.$fzH2,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.42',
    letterSpacing: 'normal',
    marginBottom: '30px',
  },
  mt40: {
    marginTop: '40px',
  },
  buttonModal: {
    textAlign: 'right',
  },
  resentOtp: {
    fontSize: theme.typography.$fzH5,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.63',
    letterSpacing: 'normal',
    color: theme.palette.$clearBlue,
    marginTop: '5px',
  },
  headerModal: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '26px',
    '& img': {

    },
    '& span': {
      fontSize: theme.typography.$fzH2,
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.42',
      letterSpacing: 'normal',
      marginLeft: '20px',
    },
  },
  description: {
    fontSize: theme.typography.$fzH4,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.67',
    letterSpacing: 'normal',
    '@media (max-width: 767px)': {
      fontSize: theme.typography.$fzH6,
      '& br': {
        display: 'none',
      },
    },
  },
  ml20: {
    marginLeft: '20px',
  },
  buttonWrapper: {
    // display: 'flex',
    textAlign: 'right',
    alignItems: 'center',
    margin: '0 auto',
    '@media (max-width: 767px)': {
      display: 'block',
    },
    '@media (min-width: 1600px)': {
      maxWidth: '1440px',
    },
    '& Button': {
      minWidth: '118px',
      height: '52px'
    }
  },
  mb40: {
    marginBottom: '40px',
  },
  iconWarning: {
    verticalAlign: 'middle',
    marginBottom: '2px',
    marginRight: '4px',
  },
  mt30: {
    marginBottom: '30px',
  },
  mt10: {
    marginTop: '10px',
  }, 
  pl8: {
    paddingLeft: '8px'
  },
  label: {
    fontSize: theme.typography.$fzH6,
    marginBottom: '10px',
  },
  brBg: {
    borderRadius: '4px',
    backgroundColor: '#F7F8F9',
    height: '50px',
  },
}), 'validate-ref-code');

const ValidateRefCode = () => {
  const [refCode, setRefCode] = useState('');
  const [errorText, setErrorText] = useState('');
  const history = useHistory();
  const [formRedux] = useState(
    useSelector((state) => state.form),
  );
  const [dynamicContent] = useState(formRedux.form && formRedux.form.dynamicContent);
  const classes = useStyles();
  const dispatch = useDispatch();
  const errorList = ['TAM2010','TAM2016','TAM2014','TAM2017']
  useEffect(() => {
    contentAPI().then(data => {
      dispatch(saveFormData({ dynamicContent: data }));
    });
  }, []);
  const validate = (code) => expirationCheck(code).then(resp => {
    if (resp) {
      if (resp.status === 'SUCCESS' && resp.data) {
        if (resp.data.expired) {
          setErrorText('The reference code has expired. Please use the Welcome Letter and PIN mailer sent to your mailbox to activate your account.');
          return;
        }
        const formData = {
          // uid: resp.data.pid,
          caseId: resp.data.caseId,
          timing: resp.data.countdownTiming,
        };
        dispatch(saveFormData(formData));
        history.push('/set-up-online/verification');
      } else if (errorList.includes(resp.error.code)) {
        setErrorText(resp.error.message || 'You have Keyed in invalid reference code');
      } else {
        history.push('/set-up-online/error');
      }
    } else {
      history.push('/set-up-online/error');
    
    }
  });
  const getRefCode = (name, value, error) => setRefCode(value);

  return (
    <>
      <Header
        namePage="Trading Account Application"
        backLink={{ name: 'Back to OCBC.com', href: '/' }}
      />

      <Container className={clsx(classes.container, classes.widthMed3)}>
        <div className={classes.title}>
          Please fill in the reference code
        </div>
        <Grid container className={classes.mt30}>
          <Grid
              item
              lg={3}
              md={4}
              sm={6}
              xs={12}
              className={clsx(classes.brBg, classes.mr60, classes.mb40, classes.wid432)}
            >
              <Input
              label="Reference code"
              placeholder=""
              value={refCode}
              errorText={errorText}
              setErrorText={setErrorText}
              type="text"
              size="large"
              kind="refCode"
              maxLength={8}
              minLength={8}
              message="Check your email for the 8 alphanumeric reference code"
              getValue={value => {
                getRefCode('refCode', value.value, value.error);
              }}
            />
            </Grid>
        </Grid>
      </Container>
      <div className={clsx(classes.buttonWrapper)}>
          <Button
            backgroundClass="bgGunmetalBluegrey"
            onClick={() => { validate(refCode); }}
            disabled={errorText || !refCode}
          >
            {'Next'}
            <ArrowRight size="24" color="currentColor" />
          </Button>
        </div>
      <Footer />
    </>
  );
};

export default ValidateRefCode;
